import { CaretUpOutlined, LeftOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import React from 'react';
import { convertAmoutToINRWithNotation } from '../../../Utils/utils';
import styles from './index.module.css';

const TopSummarySection: React.FC<{
  title: string;
  subTitle: string;
  isBackButton?: boolean;
  hideCarousel?: boolean;
  showBigTitle?: boolean;
  showCompact?: boolean;
  showInvestmentHeader?: boolean;
  onBack?: () => void;
}> = ({
  title,
  subTitle,
  isBackButton = false,
  onBack,
  showBigTitle,
  showCompact,
  hideCarousel,
  showInvestmentHeader,
}) => {
  const data = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 5800,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 5708,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 1890,
      pv: 8800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 5800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 9000,
      amt: 2100,
    },
  ];

  return (
    <div
      className={styles.commonHeaderContainer}
      style={{ width: '100%', background: '#0460ff' }}
    >
      {isBackButton ? (
        <LeftOutlined
          style={{
            position: 'absolute',
            left: 15,
            top: 20,
            color: 'white',
          }}
          onClick={onBack}
        />
      ) : (
        <></>
      )}
      <Typography.Text className={styles.commonHeaderTitle}>
        {title}
      </Typography.Text>
      {!showBigTitle ? (
        <Typography.Text className={styles.commonHeaderSubtitle}>
          {subTitle}
        </Typography.Text>
      ) : (
        <></>
      )}
      {showInvestmentHeader ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',

            alignSelf: 'flex-start',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignSelf: 'flex-start',
            }}
          >
            <Typography.Text style={{ color: 'white' }}>
              Invested:
            </Typography.Text>
            <Typography.Text style={{ marginLeft: 10, color: 'white' }}>
              {title == 'Total Mutual Funds'
                ? `₹${convertAmoutToINRWithNotation(2908000)}`
                : `₹${convertAmoutToINRWithNotation(4224819.09)}`}
            </Typography.Text>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography.Text style={{ fontWeight: 500, color: 'white' }}>
              P&L
            </Typography.Text>
            <Typography.Text
              style={{ marginLeft: 10, fontWeight: 600, color: 'white' }}
            >
              {title == 'Total Mutual Funds' ? (
                <>
                  ₹{convertAmoutToINRWithNotation(8477900)}
                  <Typography.Text style={{ color: '#0abb92' }}>
                    (
                    <CaretUpOutlined /> 29.15 %)
                  </Typography.Text>
                </>
              ) : (
                <>
                  ₹{convertAmoutToINRWithNotation(298611.76)}
                  <Typography.Text style={{ color: '#0abb92' }}>
                    (
                    <CaretUpOutlined /> 6.86 %)
                  </Typography.Text>
                </>
              )}{' '}
            </Typography.Text>
          </div>
        </div>
      ) : (
        <></>
      )}
      {showInvestmentHeader ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',

            alignSelf: 'flex-start',
          }}
        ></div>
      ) : (
        <></>
      )}
    </div>

    // <Card
    //   className='topCard'
    //   style={{ width: '100%', background: '#0460ff' }}
    //   actions={[
    //     showInvestmentHeader ? (
    //       <div
    //         style={{
    //           display: 'flex',
    //           justifyContent: 'space-between',
    //           padding: '0px 16px',
    //         }}
    //       >
    //         <div
    //           style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //           }}
    //         >
    //           <Typography.Text style={{ color: 'white' }}>
    //             Invested:
    //           </Typography.Text>
    //           <Typography.Text style={{ marginLeft: 10, color: 'white' }}>
    //             {title == 'Total Mutual Funds'
    //               ? '₹ 2,90,800.00'
    //               : '₹ 42,24,819.09'}
    //           </Typography.Text>
    //         </div>
    //       </div>
    //     ) : (
    //       <></>
    //     ),
    //     showInvestmentHeader ? (
    //       <div
    //         style={{
    //           display: 'flex',
    //           justifyContent: 'space-between',
    //           padding: '0px 16px',
    //         }}
    //       >
    //         <div
    //           style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //           }}
    //         >
    //           <Typography.Text style={{ fontWeight: 500, color: 'white' }}>
    //             P&L
    //           </Typography.Text>
    //           <Typography.Text
    //             style={{ marginLeft: 10, fontWeight: 600, color: 'white' }}
    //           >
    //             {title == 'Total Mutual Funds' ? (
    //               <>
    //                 ₹ 84,779,00{' '}
    //                 <Typography.Text style={{ color: '#0abb92' }}>
    //                   (
    //                   <CaretUpOutlined /> 29.15 %)
    //                 </Typography.Text>
    //               </>
    //             ) : (
    //               <>
    //                 ₹ 2,89,611.76{' '}
    //                 <Typography.Text style={{ color: '#0abb92' }}>
    //                   (
    //                   <CaretUpOutlined /> 6.86 %)
    //                 </Typography.Text>
    //               </>
    //             )}{' '}
    //           </Typography.Text>
    //         </div>
    //       </div>
    //     ) : (
    //       <></>
    //     ),
    //   ]}
    // >
    //   <Meta
    //     className={`cardMeta ${
    //       title === 'My Networth' ? 'alignItemsStart' : ''
    //     }`}
    //     title={<div style={{ color: 'white', fontSize: 24 }}>{subTitle}</div>}
    //     description={
    //       <div>
    //         {isBackButton ? (
    //           <LeftOutlined
    //             style={{
    //               position: 'absolute',
    //               left: 15,
    //               top: 15,
    //               color: 'white',
    //             }}
    //             onClick={onBack}
    //           />
    //         ) : (
    //           <></>
    //         )}
    //         <div
    //           style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             color: 'white',
    //             fontSize: showBigTitle ? 24 : '',
    //             fontWeight: showBigTitle ? 600 : 400,
    //           }}
    //         >
    //           {title}
    //         </div>
    //       </div>
    //     }
    //     avatar={
    //       title === 'My Networth' ? (
    //         <AreaChart
    //           width={150}
    //           height={100}
    //           data={data}
    //           margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
    //         >
    //           <defs>
    //             <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
    //               <stop offset='5%' stopColor='#8884d8' stopOpacity={0.8} />
    //               <stop offset='95%' stopColor='#8884d8' stopOpacity={0} />
    //             </linearGradient>
    //             <linearGradient id='colorPv' x1='0' y1='0' x2='0' y2='1'>
    //               <stop offset='5%' stopColor='#82ca9d' stopOpacity={0.8} />
    //               <stop offset='95%' stopColor='#82ca9d' stopOpacity={0} />
    //             </linearGradient>
    //           </defs>
    //           <Tooltip />
    //           {/* <Area type="monotone" dataKey="uv" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" /> */}
    //           <Area
    //             type='monotone'
    //             dataKey='pv'
    //             stroke='#82ca9d'
    //             fillOpacity={1}
    //             fill='url(#colorPv)'
    //           />
    //         </AreaChart>
    //       ) : (
    //         <></>
    //       )
    //     }
    //   />

    //   {hideCarousel ? (
    //     <></>
    //   ) : (
    //     <>
    //       <Divider
    //         style={{
    //           marginBottom: '0',
    //           marginTop: 15,
    //         }}
    //       />
    //       {/* <Carousel
    //     autoplay
    //     dots={false}
    //     vertical
    //     autoplaySpeed={3000}
    //     speed={1500}
    //     style={{
    //       textAlign: 'right',
    //     }}
    //   >
    //     <div>
    //       <p
    //         style={{
    //           color: 'white',
    //           fontSize: '12px',
    //         }}
    //       >
    //         Updated on 19 July 2024
    //       </p>
    //     </div>
    //     <div>
    //       <p
    //         style={{
    //           color: 'white',
    //           fontSize: '12px',
    //         }}
    //       >
    //         Next Refresh in 6 hrs
    //       </p>
    //     </div>
    //   </Carousel> */}
    //     </>
    //   )}
    // </Card>
  );
};

export default TopSummarySection;
